// This file is automatically generated. Do not edit manually.

import { IsoDateTimeString } from "src/types/dateTime";
import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { SalesLeadActivityView } from "src/api/generated/erp/db/types/tables/salesLeadActivityView";
import { SalesLead } from "src/api/generated/erp/db/types/tables/salesLead";
import { SalesLeadActivity } from "src/api/generated/erp/db/types/tables/salesLeadActivity";
import { SalesLeadActivitiesUpdateService_UpdateRequest } from "src/api/generated/erp/sales/crm/salesLeadActivities/service/salesLeadActivitiesUpdateService";
import { SalesLeadActivityCategory } from "src/api/generated/erp/db/types/tables/salesLeadActivityCategory";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SalesLeadActivitiesApi {
	export async function getActivities(args: {
		searchQuery?: string;
		salesLeadId?: number | null | undefined;
		showOpen?: boolean;
		showCompleted?: boolean;
		dueFrom?: IsoDateTimeString | null | undefined;
		dueUntilExclusive?: IsoDateTimeString | null | undefined;
		onlyOverdue?: boolean;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ServerSideDataModelResult<SalesLeadActivityView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/getActivities",
			method: "POST",
			data: {
				searchQuery: args.searchQuery,
				salesLeadId: args.salesLeadId,
				showOpen: args.showOpen,
				showCompleted: args.showCompleted,
				dueFrom: args.dueFrom,
				dueUntilExclusive: args.dueUntilExclusive,
				onlyOverdue: args.onlyOverdue,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ServerSideDataModelResult<SalesLeadActivityView>;
	}

	export async function getFormInitData(args: {
		salesLeadActivityId: number | null | undefined;
	}): Promise<SalesLeadActivitiesApi_FormInitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/getFormInitData",
			method: "POST",
			data: {
				salesLeadActivityId: args.salesLeadActivityId,
			},
		});
		return response as SalesLeadActivitiesApi_FormInitData;
	}

	export async function getSalesLeadSelectionOptions(args: {
		currentSelection: number | null | undefined;
		searchQuery?: string;
	}): Promise<Array<SalesLead>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/getSalesLeadSelectionOptions",
			method: "POST",
			data: {
				currentSelection: args.currentSelection,
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<SalesLead>;
	}

	export async function insert(args: { activity: SalesLeadActivity }): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/insert",
			method: "POST",
			data: {
				activity: args.activity,
			},
		});
		return response as number;
	}

	export async function update(args: {
		activity: SalesLeadActivitiesUpdateService_UpdateRequest;
	}): Promise<SalesLeadActivity> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/update",
			method: "POST",
			data: {
				activity: args.activity,
			},
		});
		return response as SalesLeadActivity;
	}

	export async function markAsCompleted(args: { salesLeadActivityIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/markAsCompleted",
			method: "POST",
			data: {
				salesLeadActivityIds: args.salesLeadActivityIds,
			},
		});
		return response as void;
	}

	export async function reopen(args: { salesLeadActivityIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/reopen",
			method: "POST",
			data: {
				salesLeadActivityIds: args.salesLeadActivityIds,
			},
		});
		return response as void;
	}

	export async function delete_(args: { salesLeadActivityIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/SalesLeadActivities/delete",
			method: "POST",
			data: {
				salesLeadActivityIds: args.salesLeadActivityIds,
			},
		});
		return response as void;
	}
}

export interface SalesLeadActivitiesApi_FormInitData {
	categoryOptions: Array<SalesLeadActivityCategory>;
	salesLeadActivity: SalesLeadActivity | null | undefined;
}
